import { Attachment } from "../../order-info/order-info.model";

/**
 * Interface for record form data used in party factory methods.
 * Provides type safety for request splitting and party creation.
 */
export interface RecordFormData {
  providerName: string;
  providerKeys?: any[];
  doctor?: string;
  doctorKeys?: any[];
  phone?: string | number;
  extn?: string | number;
  fax?: string;
  email?: string;
  streetAddress?: string;
  aptSuiteOther?: string;
  cityName?: string;
  stateName?: { value: string };
  zipCode?: string;
  requestUuid?: string;
  parentRequestNumber?: string;
  orderInfoAttachmentFile?: Attachment[];
  contactPhone?: string | number;
  contactPhoneExtn?: string | number;
  contactEmail?: string;
}

export const TypesOfImaging = [
    {code: 'x-rays', name: 'X-Rays'},
    {code: 'ct-scans', name: 'CT Scans' },
    {code: 'mri', name: 'MRI'},
    {code: 'ultrasound', name: 'Ultrasound'},
    {code: 'other', name: 'Other'}
];

export const TypesOfImagingInExpectedOrder = [
    'x-rays',
    'ct-scans',
    'mri',
    'ultrasound',
    'other'
]
export interface records {
    providerName: string;
    doctor: string;
    streetAddress: string;
    aptSuiteOther: string; 
    cityName: string;
    stateName: string;
    zipCode: string;
    email: string;
    subject: string;
    range: string;
    medical: string;
    billing: string;
    dental: string;
    educational: string;
    iRS: string;
    mentalHealth: string;
    millitary: string;
    pharmacy: string;
    union: string;
    subpoenaLanguageTextarea: string;
    notesTextarea: string;
    employment: string;
    recordTypeRequested: RecordTypeRequested;


}

export interface RecordTypeRequested {
    diagnosticImages: DiagnosticImages;
    ambulance: Ambulance;
    socialSecurity: SocialSecurity;
    insurance: Insurance;
    military: Military;
    va: VA;
}

export interface DiagnosticImages {
    typeOfImaging: string[];
    other: string;
    specificBodyPart:string;
}

export interface Ambulance {
    date: string;
    time: string;
    pickupAddres: string;
    pickupCity: string;
    pickupState: string;
    pickupZip: string;
    dropAddres: string;
    dropCity: string;
    dropState: string;
    dropZip: string;
}

export interface SocialSecurity {
    ss: string;
    addres: string;
    city: string;
    state: string;
    zip: string;
}

export interface Insurance {
    claimNumber: number;
    policyNumber: number;
}

export interface Military {
    branch: string;
    serviceNumber: number;
}

export interface VA {
    medical: string;
    benefit: string;
}

export const RequestedRecordTypes = [
    { name: 'Medical', key: 'medical' },
    { name: 'Billing', key: 'billing' },
    { name: 'Diagnostic Images', key: 'diagnostic-images' },
    { name: 'Ambulance', key: 'ambulance' },
    { name: 'Dental', key: 'dental' },
    { name: 'Educational', key: 'educational' },
    { name: 'Employment', key: 'employment' },
    { name: 'Insurance', key: 'insurance' },
    { name: 'IRS', key: 'irs' },
    { name: 'Mental Health', key: 'mentalHealth' },
    { name: 'Military', key: 'military' },
    { name: 'Pharmacy', key: 'pharmacy' },
    { name: 'Social Security', key: 'social-security' },
    { name: 'Union', key: 'union' },
    { name: 'VA', key: 'va' },
    { name: 'Other', key: 'other' }
];

export const RecordTypesInExpectedOrder = [
    'medical',
    'billing',
    'diagnostic-images'
];

  export const DisplayNames = [
    { name: 'Billing', key: 'billing' },
    { name: 'Diagnostic Images', key: 'diagnosticImages' },
    { name: 'Ambulance', key: 'ambulance' },
    { name: 'Dental', key: 'dental' },
    { name: 'Educational', key: 'educational' },
    { name: 'Employment', key: 'employment' },
    { name: 'Insurance', key: 'insurance' },
    { name: 'IRS', key: 'irs' },
    { name: 'Mental Health', key: 'mentalHealth' },
    { name: 'Military', key: 'military' },
    { name: 'Pharmacy', key: 'pharmacy' },
    { name: 'Social Security', key: 'socialSecurity' },
    { name: 'Union', key: 'union' },
    { name: 'VA', key: 'va' },
    { name: 'Other', key: 'other' },
    { name: 'X Ray', key: 'xray' },
    { name: 'MRI', key: 'mri' },
    { name: 'CT Scans', key: 'ctScans' },
    { name: 'Ultrasound', key: 'ultrasound' },
    { name: 'Specific Body Part/Area', key: 'specificBodyPart' },
    { name: 'Types Of Imaging', key: 'typesOfImaging' },
    { name: 'SS#', key: 'ss#' },
    { name: 'Address', key: 'address' },
    { name: 'City', key: 'city' },
    { name: 'State', key: 'state' },
    { name: 'Zip', key: 'zip' },
    { name: 'Selected Types', key: 'selectedTypes' },
    { name: 'Medical records', key: 'medical' },
    { name: 'Benefit records', key: 'benefit' },
    { name: 'Service Number (if known)', key: 'serviceNumber' },
    { name: 'Branch (if known)', key: 'branch' },
    { name: 'Claim Number', key: 'claimNumber' },
    { name: 'Policy Number', key: 'policyNumber' },
    { name: 'Pickup Address', key: 'pickupAddress' },
    { name: 'Pickup City', key: 'pickupCity' },
    { name: 'Pickup State', key: 'pickupState' },
    { name: 'Pickup Zip', key: 'pickupZip' },
	{ name: 'Drop Address', key: 'dropAddress' },
    { name: 'Drop City', key: 'dropCity' },
    { name: 'Drop State', key: 'dropState' },
    { name: 'Drop Zip', key: 'dropZip' },
    { name: 'Notes Textarea', key: 'notesTextarea' },
    { name: 'Subpoena Language Textarea', key: 'subpoenaLanguageTextarea' },
    { name: 'Description of records', key: 'descriptionOfRecords' },
    { name: 'Membership Number (if known)', key: 'membershipNumber' },
    { name: 'ProviderName', key: 'providerName' },
    { name: 'Doctor', key: 'doctor' },
    { name: 'Street Address', key: 'streetAddress' },
    { name: 'AptSuite Other', key: 'aptSuiteOther' },
    { name: 'CityName', key: 'cityName' },
    { name: 'Time', key: 'time'},
    { name: 'Date', key: 'date'},
    { name: 'Any or All', key: 'anyorall'},
    { name: 'Date to service from', key: 'dateToServiceFrom'},
    { name: 'Date to service to', key: 'dateToServiceTo'},
    { name: 'SS#', key: 'employmentSS'},
    { name: 'SS#', key: 'irsSS'},
    { name: 'SS#', key: 'socialSecuritySS'},
  ]


  export const FieldsForAdditionalDetails = [ 'diagnostic-images',
    'ambulance',
    'employment',
    'insurance',
    'irs',
    'military',
    'social-security',
    'union',
    'va',
    'other' ];




export interface Address {
    streetAddress: string;
    aptSuiteOther: string;
    cityName: string;
    stateName: State;
    zipCode: string;
}

export interface State {
    name: string;
    value: string;
}

export interface AmbulanceRes {
    date: string;  // ISO 8601 Date String
    time: string;
    pickupAddress: string;
    pickupCity: string;
    pickupState: State;
    pickupZip: string;
    dropAddress: string;
    dropCity: string;
    dropState: State;
    dropZip: string;
}

export interface SocialSecurityRes {
    socialSecuritySS: string;
    address: string;
    city: string;
    state: State;
    zip: string;
}

export interface InsuranceRes {
    claimNumber: string;
    policyNumber: string;
}

export interface MilitaryRes {
    branch: string;
    serviceNumber: string;
}

export interface VARes {
    medical: string[];
    benefit: string[];
}

export interface DiagnosticImage {
    name: string;
    code: string;
}

export interface Record {
    providerName: string;
    providerKeys: any[];
    doctorKeys: any[];
    doctor: string;
    streetAddress: string;
    aptSuiteOther: string;
    cityName: string;
    stateName: State;
    zipCode: string;
    email: string;
    phone: string;
    extn: number;
    fax: string;
    subject: string;
    range: string[];
    dateToServiceFrom: string | null;
    dateToServiceTo: string | null;
    medical: string;
    billing: string;
    dental: string;
    educational: string;
    employment: Employment;
    irs: IRS;
    mentalHealth: string;
    pharmacy: string;
    union: Union;
    other: Other;
    subpoenaLanguageTextarea: string;
    notesTextarea: string;
    diagnosticImages: DiagnosticImagesRes;
    ambulance: AmbulanceRes;
    socialSecurity: SocialSecurityRes;
    insurance: InsuranceRes;
    military: MilitaryRes;
    va: VARes;
    selectedTypes: string[];
    isEditMode: boolean;
    requestNumbers: string[];
    requestNumber?: string;
    // Request splitting fields - added for manual split functionality
    requestUuid?: string;          // UUID generated at form creation time for new requests
    parentRequestNumber?: string;  // Set only for split children - references parent's identifier
    orderInfoAttachmentFile: Attachment[];
    orderInfoAttachmentLabel: string;
    orderInfoAttachmentExplanation: string;
}

export interface Employment {
    employmentSS: string;
}

export interface IRS {
    irsSS: string;
}

export interface Union {
    membershipNumber: string;
}

export interface Other {
    descriptionOfRecords: string;
}

export interface DiagnosticImagesRes {
    typesOfImaging: DiagnosticImage[];
    other: string;
    specificBodyPart: string;
}

export interface Records {
    records: Record[];
}
